import { customFetch, AuthClient, decodeToken } from '@skytech/auth'
import { config } from '@skytech/config'

import type { TokenData, Profile } from '@/types'
import { get } from '@/util/auth'
import getUserFromToken from '@/util/getUserFromToken'

import { API_ROUTE_PROFILE } from './apiRoutes'

const userResources = {
  get: async () => {
    const res = await customFetch<{ token: string }>({
      path: 'dealer/token',
      environment: config.AUTH_API_URL,
      credentials: 'include',
    })

    const tokenData: TokenData = decodeToken(res.token)
    const user = getUserFromToken(tokenData)
    AuthClient.setToken(res.token)

    return user
  },
  getProfile: () => get<Profile>(API_ROUTE_PROFILE),
}

export default userResources
